export const countryConfigGE = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'velosipedebist-visa-da-skuterebist-vis',
    carCollection: 'mank-anis-mzg-olebist-vis'
  }
};
